// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"3acabffa","338":"9e64c111","675":"5a7fd1ed","798":"803bd4de","822":"392972e1","880":"364519fa"}[chunkId] + ".js";
};